import type { KubernetesLiveResourceHealthStatusCode, KubernetesLiveResourceSyncStatusCode } from "@octopusdeploy/octopus-server-client";
import { kubernetesLiveResourceHealthStatusCodes, kubernetesLiveResourceSyncStatusCodes } from "@octopusdeploy/octopus-server-client";
import * as React from "react";
import { LiveStatusResourceIcon } from "~/areas/projects/components/Observability/LiveStatusIcons";
import { ChipIcon, FilterTextChip, MissingChip } from "~/components/Chips";
import Lookup from "~/components/Lookup";
import { MultiSelect } from "~/components/MultiSelect/MultiSelect";
import type { SelectItem } from "~/components/VirtualListWithKeyboard/SelectItem";
import type { FormFieldProps } from "~/components/form";
interface KubernetesStatusMultiSelectProps extends FormFieldProps<string[]> {
    label?: string | JSX.Element;
    error?: string;
    accessibleName?: string;
}
interface StatusSelectItem {
    Id: KubernetesLiveResourceHealthStatusCode | KubernetesLiveResourceSyncStatusCode;
    Name: string;
    Icon: React.ReactElement;
}
const KubernetesStatusTypedMultiSelect = MultiSelect<StatusSelectItem>();
export function KubernetesHealthStatusMultiSelect(props: KubernetesStatusMultiSelectProps) {
    const { onChange, ...otherProps } = props;
    const selectItems: StatusSelectItem[] = kubernetesLiveResourceHealthStatusCodes.map((status) => ({
        Id: status,
        Name: status,
        Icon: <LiveStatusResourceIcon status={status}/>,
    }));
    return <KubernetesStatusTypedMultiSelect items={selectItems} fieldName="health status" renderChip={(item, onDeleteRequest) => chipRenderer(selectItems, item, onDeleteRequest)} onChange={(value) => onChange(value)} {...otherProps}/>;
}
export function KubernetesSyncStatusMultiSelect(props: KubernetesStatusMultiSelectProps) {
    const { onChange, ...otherProps } = props;
    const selectItems: StatusSelectItem[] = kubernetesLiveResourceSyncStatusCodes.map((status) => ({
        Id: status,
        Name: status,
        Icon: <LiveStatusResourceIcon status={status}/>,
    }));
    return <KubernetesStatusTypedMultiSelect items={selectItems} fieldName="sync status" renderChip={(item, onDeleteRequest) => chipRenderer(selectItems, item, onDeleteRequest)} onChange={(value) => onChange(value)} {...otherProps}/>;
}
function chipRenderer(selectItems: StatusSelectItem[], item: StatusSelectItem | SelectItem, onRequestDelete: () => void) {
    return (<Lookup lookupCollection={selectItems} lookupId={item.Id} getIdFromElement={(element: StatusSelectItem) => element.Id} render={(item: StatusSelectItem) => <FilterTextChip deleteButtonAccessibleName={`Delete ${item.Name}`} onRequestDelete={onRequestDelete} filterText={item.Name}/>} renderFallback={<MissingChip lookupId={item.Id} type={ChipIcon.CommunicationStyle}/>}/>);
}
